import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import fontConfig from "../../constants/fonts";
import PortFolioItem from "./PortFolioItem";
import LayoutContainer from "../../components/LayoutsContainer";
import TitleContainer from "../LogoLinks/TitleContainer";
import HTMLReactParser from "html-react-parser";
import GovernmentPortFolioItem from "./GovernmentPortFolioItem";
import { useHistory } from "react-router-dom";
import MobileHidden from "../../components/Common/Hidden/MobileHidden";
import UseMobile from "../../hooks/useIsMobile";
import DesktopHidden from "../../components/Common/Hidden/DesktopHidden";
import PortFolioCarousel from "../../Layouts/Portfolio/PortFolioCarousel";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f1f1f1",
    width: "100%",
    height: "auto",
    margin: "5vh 0vw",
    padding: "3vh 0vw",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      height: "auto",
      margin: "0vh 0vw",
      padding: "0vh 0vw 2vh 0vw",
    },

    // paddingBottom: "5vh",
  },

  titleContainer: {},
  title: {
    ...fontConfig.bold,
    fontSize: "3rem",
    color: theme.palette.primary.main,
    fontFamily: "Montserrat",
    textTransform: "uppercase",
    letterSpacing: "0.1rem",
    // backgroundColor: theme.palette.primary.main,
    borderRadius: 100,
    // boxShadow: "5px 5px 20px rgba(0,0,0,0.2)",
    // width: "20%",
    // width: "15%",
    textAlign: "center",
    padding: "20px 20px 5px 20px",
    // padding: "10 30px",
    // wordWrap: "no-wrap",
  },
  personalityContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  Paper: {
    backgroundColor: "transparent",
  },
  Divider: {
    backgroundColor: theme.palette.secondary.main,
    width: "10vw",
    height: "4px",
    borderRadius: 100,
  },
  gramInfoDescription: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),

    fontSize: "1rem",
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 5,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  gramInfoContainer: {
    marginTop: theme.spacing(2),
  },
  rightDivider: {
    borderRight: "1px solid #B8B8B8",
    height: "100%",
    width: "2px",
    padding: "0vh 0.5vw",
  },
  btn: {
    borderRadius: 100,
    marginRight: theme.spacing(2),
  },
  mobilePortfolio: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const PortFolio = ({ data }) => {
  const classes = useStyles();
  const history = useHistory();

  const handleNavigate = (link) => {
    history.push(link);
  };
  // const isMobile = UseMobile();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));
  const isTablet = useMediaQuery(theme.breakpoints.only("sm"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const sponsorvar = "વેબસાઈટ સ્પોન્સર";
  const hasSponsor = data?.governmentPeople?.data.find(
    (item) => item.occupation === sponsorvar
  );
  const govtPeople = data.governmentPeople.data.filter(
    (item) => item.occupation !== sponsorvar
  );
  const PortFolioPeople = () => {
    return (
      <Grid item lg={12} md={12} sm={12} xs={12}>
        {data?.gramPeople?.title && (
          <Grid container>
            <Grid item className={classes.titleContainer}>
              <TitleContainer title={data?.gramPeople?.title} />
            </Grid>
          </Grid>
        )}
        <MobileHidden>
          <Grid
            item
            container
            spacing={1}
            className={classes.personalityContainer}
            justify="flex-start"
          >
            {data.gramPeople.data.map((man, index) => {
              return (
                <Grid item key={index}>
                  <PortFolioItem data={man} />
                </Grid>
              );
            })}
          </Grid>
        </MobileHidden>

        <DesktopHidden>
          <Grid
            item
            md={12}
            sm={12}
            xs={12}
            className={classes.mobilePortfolio}
          >
            {data.gramPeople.data.map((man, index) => {
              return (
                <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
                  <GovernmentPortFolioItem data={man} />
                </Grid>
              );
            })}
            {/* <PortFolioCarousel data={data?.gramPeople.data} /> */}
          </Grid>
        </DesktopHidden>
      </Grid>
    );
  };

  const AboutGram = () => {
    return (
      <Grid item container lg={12} md={12} sm={12} xs={12}>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className={classes.gramInfoContainer}
        >
          {data?.gramInfo?.title && (
            <Grid container>
              <Grid item className={classes.titleContainer}>
                <TitleContainer title={data?.gramInfo?.title} />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item lg={12}>
          <Typography variant="body1" className={classes.gramInfoDescription}>
            {data?.gramInfo?.description
              ? HTMLReactParser(data?.gramInfo?.description)
              : undefined}
          </Typography>
        </Grid>
        {data?.gramInfo.linkTitle && (
          <Grid item lg={12} container justify="flex-end">
            <Button
              color="primary"
              variant="outlined"
              className={classes.btn}
              onClick={() => handleNavigate(data?.gramInfo?.link)}
            >
              {data?.gramInfo.linkTitle}
            </Button>
          </Grid>
        )}
      </Grid>
    );
  };

  const UpDown = () => {
    return isMobile ? (
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <PortFolioPeople />
        <AboutGram />
      </Grid>
    ) : (
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <PortFolioPeople />

        <AboutGram />
      </Grid>
    );
  };
  return (
    <>
      <div className={classes.root}>
        <LayoutContainer>
          <Grid container>
            <Grid
              item
              lg={8}
              md={8}
              sm={12}
              xs={12}
              container
              direction="column"
            >
              <UpDown />
            </Grid>

            <Grid item lg={4} md={12} sm={12} xs={12} container>
              <MobileHidden>
                <Grid item lg={1}>
                  <div className={classes.rightDivider} />
                </Grid>
              </MobileHidden>

              <Grid item container lg={11} md={12} sm={12} xs={12}>
                <Grid item lg={12}>
                  {!hasSponsor && data?.governmentPeople?.title && (
                    <Grid container>
                      <Grid item className={classes.titleContainer}>
                        <TitleContainer title={data?.governmentPeople?.title} />
                      </Grid>
                    </Grid>
                  )}
                  {hasSponsor && (
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <GovernmentPortFolioItem data={hasSponsor} />
                    </Grid>
                  )}
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    container
                    direction={isMobile ? "row" : "column"}
                    spacing={isMobile ? 0 : 3}
                    justify="space-between"
                    alignItems="center"
                    className={
                      isMobile ? undefined : classes.personalityContainer
                    }
                  >
                    {govtPeople.map((man, index) => {
                      return (
                        <Grid item lg={12} md={12} sm={12} xs={12} key={index}>
                          <GovernmentPortFolioItem data={man} />
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </LayoutContainer>
      </div>
    </>
  );
};
export default PortFolio;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     [theme.breakpoints.down("md")]: {
//       backgroundColor: "white",
//     },
//   },
// }));

// const PortFolio = () => {
//   const classes = useStyles();

//   return (
//     <div className={classes.root}>
//       <section
//         id="portfolioCarousel"
//         class="portfolio-carousel portfolio-classic pt-90 pb-70"
//       >
//         <div class="container">
//           <div class="row mb-50">
//             <div class="col-sm-12 col-md-12 col-lg-7">
//               <div class="heading">
//                 <span class="heading__subtitle">
//                   We Work With Global Industries!
//                 </span>
//                 <h3 class="heading__title mb-0">Featured portfolio</h3>
//               </div>
//             </div>
//             {/* <div class="col-sm-12 col-md-12 col-lg-5">
//               <div class="cta__banner">
//                 <div class="bg-img">
//                   <img
//                     src="assets/images/backgrounds/pattern/1.jpg"
//                     alt="background"
//                   />
//                 </div>
//                 <h5 class="cta__title">
//                   Dedicated Customer <br /> Teams &amp; An Agile Services
//                 </h5>
//                 <p class="cta__desc">
//                   Building relationships and portfolio that last. Serving an
//                   impressive list of long-term clients with experience and
//                   expertise in industries.
//                 </p>
//                 <a class="btn btn__white btn__link" href="#">
//                   {" "}
//                   View Our Works{" "}
//                 </a>
//               </div>
//             </div> */}
//           </div>
//           <div class="row">
//             <div class="col-sm-12 col-md-12 col-lg-12">
//               <div
//                 class="carousel owl-carousel carousel-arrows"
//                 data-slide="3"
//                 data-slide-md="2"
//                 data-slide-sm="1"
//                 data-autoplay="true"
//                 data-nav="true"
//                 data-dots="false"
//                 data-space="30"
//                 data-loop="true"
//                 data-speed="800"
//               >
//                 <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p3.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     {/* <a class="view__icon" href="#">
//                       View
//                     </a> */}
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">શ્રી અમરેન્દ્ર કુમાર રાકેશ​ આઇ. એ. એસ.</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">
//                         અધિક મુખ્ય સચિવશ્રી (પંચાયત, ગ્રામ ગૃહનિર્માણ અને ગ્રામ
//                         વિકાસ વિભાગ)
//                       </a>
//                       {/* <a href="#">oil &amp; Gas</a> */}
//                     </div>
//                   </div>
//                 </div>
//                 <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p4.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     {/* <a class="view__icon" href="#">
//                       View
//                     </a> */}
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">પ્રહલાદભાઈ એચ. પટેલ</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">ઉપ સરપંચશ્રી </a>
//                       <a href="#">+૯૧-૯૦૯ ૯૪૨ ૨૮૬૦</a>
//                     </div>
//                   </div>
//                 </div>
//                 <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p1.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     {/* <a class="view__icon" href="#">
//                       View
//                     </a> */}
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">શ્રી રામાજી રાણાજી વણઝારા</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">ગ્રામસેવક</a>
//                       <a href="#">+૯૧-૭૮૭૪૨૪૪૯૩૫</a>
//                     </div>
//                   </div>
//                 </div>
//                 {/* <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p2.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     <a class="view__icon" href="#">
//                       View
//                     </a>
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">Regulatory Compliance Seminar</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">Construction</a>
//                       <a href="#">Engineering</a>
//                     </div>
//                   </div>
//                 </div>
//                 <div class="portfolio-item">
//                   <div class="portfolio__img">
//                     <img
//                       src="http://jepurpanchayat.com/assets/images/products/p3.jpg"
//                       alt="portfolio img"
//                     />{" "}
//                     <a class="view__icon" href="#">
//                       View
//                     </a>
//                   </div>
//                   <div class="portfolio__content">
//                     <h4 class="portfolio__title">
//                       <a href="#">Documents &amp; Electronic Data</a>
//                     </h4>
//                     <div class="portfolio__cat">
//                       <a href="#">Engineering</a>
//                       <a href="#">oil &amp; Gas</a>
//                     </div>
//                   </div>
//                 </div> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };
// export default PortFolio;
